/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getBookmarks.defs.js'
export { main as default } from './getBookmarks.defs.js'
